// extracted by mini-css-extract-plugin
module.exports = {"ajioLogo":"_3Dkwb","logoHeading":"_1_IwM","ajioLogo_image":"_34ksU","shake":"_2nQFv"};